// extracted by mini-css-extract-plugin
export var copyableItem = "_4g-0";
export var underlined = "_4g-1";